import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FastField } from 'formik';
import * as Yup from 'yup';

import { BaseButtonFill, BaseInput, InputField } from '..';
import LoginMessages from '../LoginMessages/LoginMessages';
import UserCommonView from '../UserCommonView/UserCommonView';

import { requiredStringValidator } from '../../helpers/form.helper';

import './BaseLogin.scss';

const BaseLogin = ({ login, warning, heading, subheading, isAdvisor, isAdmin = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loginLoading, setLoginLoading] = useState(false);
  const { t: common } = useTranslation('common');

  const initialFormValues = {
    email: '',
    password: '',
  };

  const validationSchema = Yup.object().shape({
    email: requiredStringValidator().email(common('errors.email')),
    password: requiredStringValidator(),
  });

  const onSubmit = async (values) => {
    setLoginLoading(true);

    try {
      // Unauthenticated route will redirect us to list automatically.
      // returnUrl needed for transferring user back to document if id is provided.
      const returnUrl = location.search ? location.search.replace('?', '/') : '';
      await login(values);

      if (returnUrl) {
        navigate(returnUrl);
      }
    } catch (error) {
      warning(error);
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <UserCommonView
      isAdvisor={isAdvisor}
      heading={heading}
      subheading={subheading}
      initialFormValues={initialFormValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      leftContent={isAdmin ? null : <LoginMessages />}
    >
      <div className="row">
        <InputField name="email" label={common('login.email')} />
      </div>
      <div className="row user-login-password">
        <FastField
          component={BaseInput}
          name="password"
          type="password"
          label={common('login.password')}
          data-testid="password"
        />
      </div>
      <div className="row user-common-view__forgot-password-link">
        <Link to="/forgot-password" data-testid="forgot-password-link">
          {common('forgotPassword.heading')}
        </Link>
      </div>
      <div className="row">
        <BaseButtonFill
          type="submit"
          full
          large
          loading={loginLoading}
          iconRight
          icon="arrow-right"
          data-testid="login-button"
        >
          {common('login.button')}
        </BaseButtonFill>
      </div>
    </UserCommonView>
  );
};

export default BaseLogin;
